import z from "zod";
import {
  AVAILABILITY_DATE_NOT_IN_PAST_MESSAGE,
  isAvailabilityDateYmdNotInPast,
} from "./availability-date-validation";

export const specialHourSchema = z
  .object({
    teacherId: z.number().min(1, { message: "Teacher ID is required" }),
    date: z.string().min(1, { message: "Date is required" }),
    startTime: z.string().min(1, { message: "Start time is required" }),
    endTime: z.string().min(1, { message: "End time is required" }),
    locationId: z.number({ message: "Location is required" }).min(1, {
      message: "Location is required",
    }),
  })
  .refine((data) => isAvailabilityDateYmdNotInPast(data.date), {
    message: AVAILABILITY_DATE_NOT_IN_PAST_MESSAGE,
    path: ["date"],
  })
  .refine(
    (data) => {
      const start = data.startTime;
      const end = data.endTime;
      if (start && end) {
        return end > start;
      }
      return true;
    },
    {
      message: "End time must be after start time",
      path: ["endTime"],
    },
  );

export type SpecialHourSchemaType = z.infer<typeof specialHourSchema>;
